
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/comment",
      function () {
        return require("private-next-pages/visitor/comment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/comment"])
      });
    }
  